// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"580e5ba1","803":"2d3ce16e","891":"acd3fea5"}[chunkId] + ".chunk.js";
};